export default "/images/vendor/flag-icons/flags/1x1/us.svg?8521a232fc83a880eaf74df4abfc5b18";